/**
 * Divider — atom (ADR-0007). Horizontal with optional inline label («или email»).
 */
export function Divider({ label, className = '' }: { label?: string; className?: string }) {
  if (label) {
    return (
      <div className={`flex items-center gap-3 my-6 text-text-muted text-xs font-medium uppercase tracking-wider ${className}`}>
        <span className="flex-1 h-px bg-border-strong" aria-hidden="true" />
        {label}
        <span className="flex-1 h-px bg-border-strong" aria-hidden="true" />
      </div>
    )
  }
  return <hr className={`border-0 h-px bg-border-strong ${className}`} />
}
